<!-- The ng-template is used so that the popup's content is not rendered where the popup is defined -->
<ng-template>
  <div class="mc-popup">
    <div class="mc-popup-content">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
